import "./WikiSection.scss"

import { useEffect, useRef } from "react"

import { useHelpCenterContext } from "../../contexts/HelpCenterContext"
import { WikiSectionProps } from "../../types"

function WikiSection(props: WikiSectionProps) {
  const sectionRef = useRef<HTMLElement>(null)
  const { setActiveSectionId } = useHelpCenterContext()

  useEffect(() => {
    if (!sectionRef.current) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSectionId(props.id)
          }
        })
      },
      {
        rootMargin: "-20% 0px -60% 0px",
        threshold: 0
      }
    )

    observer.observe(sectionRef.current)

    return () => observer.disconnect()
  }, [props.id, setActiveSectionId])

  return (
    <section ref={sectionRef} id={props.id} className="wiki-section">
      <h2 className="wiki-section__title">{props.title}</h2>
      <div className="wiki-section__content">{props.children}</div>
    </section>
  )
}

export default WikiSection
